import { Box, Typography } from "@mui/material";

import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";

import { getStaffRoleColor } from "./UserAvatar.utils";

interface Props {
  label: string;
  role?: UserPermission;
  size?: number;
}

export function UserAvatar({ label, role, size = 40 }: Props) {
  return (
    <Box
      aria-hidden
      sx={(theme) => ({
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: role ? getStaffRoleColor(theme, role) : theme.palette.action.active,
      })}
    >
      <Typography sx={{ color: "common.white" }}>{label}</Typography>
    </Box>
  );
}
